import * as CONST from '../common/const';
import api from 'utils/api';
import { logger } from '@amzn/awsui-components-react/polaris/internal/core/runtime/src';

export const fetchColumnMetadataRequest = () => {
  return {
    type: CONST.FETCH_COLUMN_METADATA_REQUEST
  }
}

export const fetchColumnMetadataSuccess = (columnMetadata) => {
  return {
    type: CONST.FETCH_COLUMN_METADATA_SUCCESS,
    columnMetadata: columnMetadata.ColumnMetadata
  }
}

export const fetchColumnMetadataFailure = (error) => {
  return {
    type: CONST.FETCH_COLUMN_METADATA_FAILURE,
    error: error,
  };
};


export const fetchColumnMetadata = () => async (dispatch, getState) => {

  dispatch(fetchColumnMetadataRequest());
  try {
    const result = await api.getColumnMetadata();
    dispatch(fetchColumnMetadataSuccess(result));
  } catch (e) {
    dispatch(fetchColumnMetadataFailure(e));
  }
};